export const EN_TRANS = {
  submit: "Submit",
  writeHere: "Write Here..",
  pleaseAnswerThisQuestion: "Please answer this question",
  pleaseUploadFile: "Please upload file",
  pleaseSign : "Please sign here"
};

export default EN_TRANS;